const type = 'SET_RECHARGE_EMAIL_SENDING';

const setRechargeEmailSending = (data) => ({
  data,
  type,
});

export default setRechargeEmailSending;
